import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export const apiGetScreenTileChildren = async (tileId, screenId, playlistId) => {
  try {
    const url = `${config.apiUrl}userapi/screens/${screenId}/local-template/${tileId}/children?playlist_id=${playlistId}`;

    return await http.get(url);
  } catch (error) {
    logger.addLog(
      `Local template's children API failed: ${error?.message}. Local template: ${tileId}. ${
        playlistId ? `Playlist: ${playlistId}` : ''
      }`,
    );

    return null;
  }
};
